import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../contexts/authContext';
import { deliveryClient } from '../../lib/connect/clients';
// Phase 5c — the signed-in user's delivery notification inbox. ryugu resolves
// the recipient server-side from the gateway principal (the request never names
// a user) and projects per program, so a notification whose source program the
// recipient can no longer see is suppressed and disclosed as hidden_count
// (DRIFT-2) — being the routed owner does not bypass NoView.
const KEY = 'delivery-notifications';
/**
 * shareWithBell (SAD-1005): a reader beside the bell (the Dashboard rail)
 * takes the bell's cached inbox instead of fetching it again on mount; the
 * bell's own 30 s poll keeps it fresh.
 */ export function useMyNotifications(companyId, { shareWithBell = false } = {}) {
    const { user } = useAuth();
    return useQuery({
        queryKey: [
            KEY,
            companyId,
            user?.id
        ],
        queryFn: async ()=>{
            const resp = await deliveryClient.listMyNotifications({
                companyId,
                unacknowledgedOnly: false
            });
            return {
                notifications: resp.notifications,
                hiddenCount: resp.hiddenCount
            };
        },
        enabled: !!companyId,
        staleTime: 0,
        refetchInterval: 30000,
        refetchOnMount: !shareWithBell
    });
}
export function useAcknowledgeNotification(companyId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (recipientId)=>deliveryClient.acknowledgeNotification({
                companyId,
                recipientId
            }),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    KEY,
                    companyId
                ]
            });
        }
    });
}
export function useAcknowledgeAllNotifications(companyId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ()=>deliveryClient.acknowledgeAllNotifications({
                companyId
            }),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    KEY,
                    companyId
                ]
            });
        }
    });
}
